import { type Step } from "../../../types";

export const intro_steps_1: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Вы подключаете кабинет к нашему сервису за 5 минут через наше приложение.",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value: "Данные ежедневно загружаются в вашу Google-таблицу.",
      },
    ],
  },
  {
    index: 3,
    content: [
      {
        type: "NoIconText",
        value:
          "Помимо наших готовых листов, вы можете кастомизировать свою Google-таблицу как угодно: добавлять новые листы, формулы, графики и собственные метрики. А мы гарантируем, что данные в ней всегда будут корректными и актуальными.",
      },
    ],
  },
];

export const intro_steps_2: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Метрики: Заказы, Продажи, ДРР, CTR, CPC, CR, СПП, СВР, CPM, CPO, CPS, CPL",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value: "Остатки и логистика: Актуальные остатки FBW складах.",
      },
    ],
  },
  {
    index: 3,
    content: [
      {
        type: "NoIconText",
        value:
          "Аналитика по артикулам / склейкам, чтобы быстро принимать решения.",
      },
    ],
  },
];

export const intro_steps_3: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Экономит 2–3 часа в день: Больше не нужно вручную выгружать и сводить данные из разных источников.",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value: "Мобильность: Доступна через приложение Google-Таблицы.",
      },
    ],
  },
  {
    index: 3,
    content: [
      {
        type: "NoIconText",
        value: "Простота: Удобно работать в команде.",
      },
    ],
  },
  {
    index: 4,
    content: [
      {
        type: "NoIconText",
        value:
          "Концентрация на главном: Вместо рутины — анализ и стратегия для роста вашего бизнеса.",
      },
    ],
  },
  {
    index: 5,
    content: [
      {
        type: "NoIconText",
        value: "Быстрая поддержка",
      },
    ],
  },
];
